import React from "react";

type SkeletonProps = {
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

const Skeleton = ({ className = "", ...props }: SkeletonProps) => {
  return (
    <div
      className={`animate-pulse rounded-none bg-white/10 ${className}`}
      {...props}
    />
  );
};

export default Skeleton;
